import { render, staticRenderFns } from "./CatalogueStatus.vue?vue&type=template&id=27ebcb22&scoped=true"
import script from "./CatalogueStatus.vue?vue&type=script&lang=js"
export * from "./CatalogueStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ebcb22",
  null
  
)

export default component.exports